import { render, staticRenderFns } from "./Sorter.vue?vue&type=template&id=3fed490a&"
import script from "./Sorter.vue?vue&type=script&lang=js&"
export * from "./Sorter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/Kristian/Local Sites/boligvelger/app/public/wp-content/plugins/ensign-boligprosjekter-blocks/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fed490a')) {
      api.createRecord('3fed490a', component.options)
    } else {
      api.reload('3fed490a', component.options)
    }
    module.hot.accept("./Sorter.vue?vue&type=template&id=3fed490a&", function () {
      api.rerender('3fed490a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Sorter.vue"
export default component.exports